"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var _ = require("lodash");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var enums_1 = require("../../common/enums");
var ResetPassword = /** @class */ (function (_super) {
    tslib_1.__extends(ResetPassword, _super);
    function ResetPassword(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.checkPassword = function (password) {
            var checkPassword = _this.props.checkPassword;
            _this.setState({ changingPassword: false });
            checkPassword(password);
        };
        _this.onChange = function (e) {
            var _a;
            var checkPassword = _this.props.checkPassword;
            var changingPassword = _this.state.changingPassword;
            var nextState = (_a = {},
                _a[e.target.name] = e.target.value,
                _a);
            if (e.target.name === "password") {
                !nextState.changingPassword && (nextState.changingPassword = true);
                _this.checkPassword(e.target.value);
            }
            _this.setState(nextState);
        };
        _this.onResetPassword = function () {
            var onResetPassword = _this.props.onResetPassword;
            var password = _this.state.password;
            onResetPassword(password);
        };
        _this.state = { password: "", confirmedPassword: "", changingPassword: false };
        _this.checkPassword = _.debounce(_this.checkPassword, 500, { trailing: true });
        return _this;
    }
    Object.defineProperty(ResetPassword.prototype, "disableButton", {
        get: function () {
            var _a = this.props, passwordScore = _a.passwordScore, minPasswordScore = _a.minPasswordScore;
            var _b = this.state, password = _b.password, confirmedPassword = _b.confirmedPassword;
            return !password || (password !== confirmedPassword) || (passwordScore < minPasswordScore);
        },
        enumerable: true,
        configurable: true
    });
    ResetPassword.prototype.renderForm = function () {
        var _a = this.props, isCheckingPassword = _a.isCheckingPassword, passwordScore = _a.passwordScore, isOldPasswordError = _a.isOldPasswordError;
        var _b = this.state, changingPassword = _b.changingPassword, password = _b.password;
        return (React.createElement("div", { className: theme.container },
            React.createElement("div", { className: theme.text }, "Reset your password"),
            React.createElement(ui_1.Form, { className: theme.form, onSubmit: this.onResetPassword },
                React.createElement(ui_1.AggregateChangeComponent, { onChange: this.onChange },
                    React.createElement(ui_1.FormInput, { fill: true, type: "password", className: theme.input, label: "Password", name: "password" }),
                    React.createElement(ui_1.PasswordStrength, { className: theme.strenght, score: passwordScore, isChecking: isCheckingPassword || changingPassword }),
                    React.createElement(ui_1.FormInput, { fill: true, type: "password", className: theme.input, label: "Confirm Password", name: "confirmedPassword" })),
                React.createElement(ui_1.Button, { type: "submit", disabled: this.disableButton, className: theme.button, fill: true, large: true, blue: true, uppercase: true }, "Set New Password"),
                isOldPasswordError ? (React.createElement("div", { className: theme.error }, "A new password cannot be the same as an old one.")) : null)));
    };
    ResetPassword.prototype.renderLoader = function () {
        return (React.createElement(ui_1.CircleLoader, { className: theme.loader, size: 6, blue: true }));
    };
    ResetPassword.prototype.renderError = function () {
        var error = this.props.error;
        var message;
        switch (error) {
            case enums_1.ResetPasswordErrorCode.TokenExpired:
                message = "Reset password token expired.";
                break;
            case enums_1.ResetPasswordErrorCode.GeneralError:
            default:
                message = "Something went wrong.";
        }
        return (React.createElement("div", { className: theme.container },
            React.createElement(ui_1.Icon, { iconName: "icon-rejected-status", className: theme.icon, size: 6 }),
            React.createElement("div", { className: classnames(theme.text, theme.message) },
                React.createElement("div", null, message),
                React.createElement("div", null, "Please try again"))));
    };
    ResetPassword.prototype.renderCompleteMessage = function () {
        return (React.createElement("div", { className: theme.container },
            React.createElement(ui_1.Icon, { iconName: "icon-approved-status", className: theme.icon, size: 6 }),
            React.createElement("div", { className: classnames(theme.text, theme.message) },
                React.createElement("div", null, "Your password has been"),
                React.createElement("div", null, "successfully reset"))));
    };
    ResetPassword.prototype.renderLogo = function () {
        var renderLogo = this.props.renderLogo;
        if (typeof renderLogo === "function") {
            return renderLogo();
        }
        return renderLogo;
    };
    ResetPassword.prototype.render = function () {
        var _a = this.props, error = _a.error, isComplete = _a.isComplete, isLoading = _a.isLoading, onSignIn = _a.onSignIn, isOldPasswordError = _a.isOldPasswordError;
        return (React.createElement(ui_1.PageContainer, { pageTitle: "Reset Password", className: theme.reset },
            React.createElement("div", { className: theme.logo }, this.renderLogo()),
            (!error || isOldPasswordError) && !isComplete && !isLoading ? this.renderForm() : null,
            isLoading ? this.renderLoader() : null,
            (error && !isOldPasswordError) ? this.renderError() : null,
            isComplete ? this.renderCompleteMessage() : null,
            onSignIn ? (React.createElement("div", { className: theme.footerLink },
                "Return to ",
                React.createElement("a", { onClick: onSignIn }, "sign in"))) : null));
    };
    ResetPassword.defaultProps = {
        minPasswordScore: 3
    };
    return ResetPassword;
}(React.Component));
exports.default = ResetPassword;
